import Vue from "vue";
import Vuex from "vuex";
import offersModule from "./modules/offers";
import authModule from "./modules/auth";
import parcelModule from "./modules/parcels";
import presentationsModule from "./modules/presentations";
import projectsModule from "./modules/projects";
import settingsModule from "./modules/settings";
import defaulModule from "./modules/default";
import axios from "axios";

Vue.use(Vuex);

axios.interceptors.request.use(config => {
  if (config.url.includes("https://")) return config;
  if (
    config.url.includes("uldk.gugik.gov.pl") ||
    config.url.includes("mapy.geoportal.gov.pl")
  ) {
    return config;
  }
  return Object.assign(config, {
    url: `${process.env.VUE_APP_API_URL}${config.url}`,
    headers: {
      Authorization: localStorage.getItem("token")
    }
  });
});

export default new Vuex.Store({
  modules: {
    authModule,
    offersModule,
    parcelModule,
    presentationsModule,
    projectsModule,
    settingsModule,
    defaulModule
  }
});
